import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'

const styles = {
  topBox: {
    gridColumn: '1/3',
    padding: '16px',
    backgroundColor: '#fff',
    width: '100%',
    borderBottom: '1px solid lightgray'
  },
  gridBoxes: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0,1fr))',
    // gridTemplateRows: 'auto 20px',
    width: '100%',
    // marginBottom: '8px',
    // height: '20px'
  },
  labelBox: {
    textAlign: 'right',
    fontSize: '12px'
  },
  barContainer: {
    // gridRow: '2/3',
    height: '20px',
    borderRadius: '20px',
    // border: '1px solid lightgray',
    backgroundColor: 'lightgray',
    display: 'flex',
    overflow: 'hidden'
  },
  barBox: {
    flex: 1,
  },
  barBorder: {
        borderRight: '5px solid #fff'

  },
  filledBar: {
    backgroundColor: 'primary.main'
  },
  emptyBar: {
  },
  savingsText: {
    marginTop: '8px'
  }
}

export default function VolumeDiscountBar({discount, couponApplied}) {
  const percents = [
    { id: '5-percent', value: 5 },
    { id: '10-percent', value: 10 },
    { id: '15-percent', value: 15 },
    { id: '20-percent', value: 20 }
  ]
  //Conditional phrases
  const currDiscount = () => {
    let discountValue = discount*100
    if (discountValue === 0) {
      return 'Add a camp to your cart to start saving.'
    } else if (discountValue === 20) {
      return "You're saving 20% off!"
    } else {
      return `Add another camp to save ${discountValue + 5}% off!`
    }
  }
  //Conditional styling for the bar
  const fillStyle = (value) => {
    let style = {}
    if (value !== 20) {
      style = {...styles.barBorder}
    }
    if (value <= discount*100) {
      style = {...style, ...styles.filledBar}
    }
    return style
  }

  return (
    <Box sx={styles.topBox}>
      {couponApplied.value > 0 ? <>Coupons cannot be combined with bulk discount</> :<><span>
        <Typography variant='h6' display='inline'>More Camps = More Savings! </Typography>
        <Typography display='inline'>Save up to 20%</Typography>
      </span>
      <Box sx={styles.gridBoxes}>
        {percents.map((percent) => (
          <Box
            id={percent.id + '-label'}
            key={percent.id + '-label'}
            sx={styles.labelBox}
          >
            {percent.value}%
          </Box>
        ))}
      </Box>
      <Box sx={{ ...styles.barContainer, ...styles.gridBoxes }}>
        {percents.map((percent) => (
          <Box
            id={percent.id + '-bar'}
            key={percent.id + '-bar'}
            sx={{ ...styles.barBox, ...fillStyle(percent.value) }}
          ></Box>
        ))}
      </Box>

      <Typography variant='body2' sx={styles.savingsText}>
        {currDiscount()}
      </Typography></>}
    </Box>
  )
}
